import React from 'react'
import Manager from '../../public/components/Manager'
import BatchSpecialLeaveDetail from './BatchSpecialLeaveDetail'
Ext.require('Ext.Toast')

const config = props => {
    return {
        tabs: {
            '申请中': {
                buttons: [
                    { text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <BatchSpecialLeaveDetail {...props} id={0} />) },
                ],
                columns: [
                    { _text: '记录编号', field: 'Number', minWidth: 150, search: true, flex: 1, },
                    { _text: '记录名称', field: 'Name', minWidth: 250, search: true, flex: 1, },
                    { _text: '创建人', field: 'Creator', minWidth: 150, filter: true, align: 'left', flex: 1 },
                    { _datetime: '创建时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
                ],
                onDoubleTap: ({ showDetail, refreshPage }, data) => {
                    showDetail(props => <BatchSpecialLeaveDetail {...props} id={data.id} />)
                }
            },
            '退回申请': {
                buttons: [
                ],
                columns: [
                    { _text: '记录编号', field: 'Number', minWidth: 150, search: true, flex: 1, },
                    { _text: '记录名称', field: 'Name', minWidth: 250, search: true, flex: 1, },
                    { _text: '创建人', field: 'Creator', minWidth: 150, filter: true, align: 'left', flex: 1 },
                    { _datetime: '创建时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
                    { _: 'taskName', field: 'Task.TaskName' }
                ],
                onDoubleTap: ({ showDetail, refreshPage }, data) => {
                    showDetail(props => <BatchSpecialLeaveDetail {...props} id={data.id} taskName={data.taskName} />)
                }
            },
            '签核中': {
                buttons: [
                ],
                columns: [
                    { _text: '记录编号', field: 'Number', minWidth: 150, search: true, flex: 1, },
                    { _text: '记录名称', field: 'Name', minWidth: 250, search: true, flex: 1, },
                    { _text: '创建人', field: 'Creator', minWidth: 150, filter: true, align: 'left', flex: 1 },
                    { _datetime: '创建时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
                    { _: 'taskName', field: 'Task.TaskName' }
                ],
                onDoubleTap: ({ showDetail, refreshPage }, data) => {
                    showDetail(props => <BatchSpecialLeaveDetail {...props} id={data.id} taskName={data.taskName} />)
                }
            },
            '已完成':
            {
                buttons: [
                ],
                columns: [
                    { _text: '记录编号', field: 'Number', minWidth: 150, search: true, flex: 1, },
                    { _text: '记录名称', field: 'Name', minWidth: 250, search: true, flex: 1, },
                    { _text: '创建人', field: 'Creator', minWidth: 150, filter: true, align: 'left', flex: 1 },
                    { _datetime: '创建时间', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
                ],
                onDoubleTap: ({ showDetail, refreshPage }, data) => {
                    showDetail(props => <BatchSpecialLeaveDetail {...props} id={data.id} />)
                }
            }
        }
    }
}

export default props => <Manager {...props} config={config} />